import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import EmailIcon from '../../assets/formComponents/emailIcon.svg';
import apiHost from '../../apiHost';
import { BlueButton, H1, H2 } from '../StyledComponents';
import EsperLogoBlue from '../../assets/v2/esper_light.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import axios from 'axios';
import { Link, navigate, graphql, StaticQuery } from 'gatsby';
import { ImgDesktop } from './EsperSignUpFormComponent';

const barberpole = keyframes`
  100% {
    background-position: 100% 100%;
  }
`;

export const BlueButtonNew = styled(BlueButton)`
  background-color: #664eab;
  min-width: 356px;
  width: fit-content !important;
  margin: 0rem !important;
  font-size: 22px;
  height: 50px;
  background-image: ${(props: { isLoading: boolean }) =>
    props.isLoading
      ? `repeating-linear-gradient(
      -45deg,
      #7a55a5,
      #7a55a5 1rem,
      #634487 1rem,
      #634487 2rem
    )`
      : ''};

  animation: ${(props: { isLoading: boolean }) =>
    props.isLoading
      ? css`
          ${barberpole} 4s linear reverse infinite
        `
      : ``};
  background-size: 200% 200%;
  /* justify-self: center; */

  @media (max-width: 768px) {
    font-size: 16px !important;
  }
`;

const WhiteButton = styled(BlueButtonNew)`
  background: transparent;
  border: 1px solid #664eab;
  color: #664eab;
  box-shadow: none;
`;

// @ts-ignore
const StyledInputs = styled.input`
  :focus {
    color: #495057;
    background-color: ##f4f5f7;
    border: rgb(76, 154, 255) 2px solid;
    outline: 0;
    box-shadow: 0 0 0 0.1rem rgba(0, 123, 255, 0.25);
    color: black;
    background-image: none;
  }
  background-color: #f4f5f7;
  box-shadow: ${(props: { error: boolean }) =>
    props.error ? '0 0 0 0.1rem #fd7e7e5e' : 'none'};
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  @media (max-width: 520px) {
    font-size: 12px;
  }
  line-height: 1.43;
  ::placeholder {
    color: rgba(107, 124, 147, 0.6);
    opacity: 1; /* Firefox */
  }
  padding: 1.07em 0.5em;
  margin-top: 10px;
  height: 50px;
  width: 100%;
  min-width: 350px;
  border: solid 2px #cacaca;
  border-color: ${(props: { error: boolean }) =>
    props.error ? '#eb6161' : 'rgba(107, 124, 147, 0.43)'};
  padding: 0.475rem 0.75rem 0.475rem 1.5rem;
  border-radius: 4px;
  background-position-y: center;
  background-position-x: 0.5rem;
  background-repeat: no-repeat;
  text-indent: 20px;

  background-size: 18px 18px;
`;

const FormComponent = styled.div`
  display: grid;
  position: relative;
  padding: 0;
  justify-self: center;
  min-height: 100vh;
  /* box-shadow: 3px 2px 26px 0 rgba(112, 112, 112, 0.15); */
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
  padding-bottom: 0rem !important;
  padding-top: 0rem !important;
  /* margin-top: 12rem; */
  justify-items: center;
`;

const FormComponentLeft = styled.div`
  padding: 7rem 6rem;
  display: grid;
  align-content: center;
  grid-column: span 1;
  justify-items: center;
  background-image: linear-gradient(
    34deg,
    #9a6ad3 -25%,
    #7757b8 -2%,
    #5847a0 52%
  );
  width: 100%;

  @media (max-width: 1440px) {
    padding: 7rem 3rem;
  }
  @media (max-width: 768px) {
    border-radius: 8px 8px 0px 0px;
    display: none;
  }
  @media (max-width: 520px) {
    padding: 7rem 5rem;
    display: none;
  }
  @media (max-width: 400px) {
    padding: 6rem 2rem;
  }
`;

const FormComponentRight = styled.div`
  padding: 2rem 2rem 1.5rem 3rem;

  grid-column: span 2;
  background: #ffffff;
  display: grid;
  grid-gap: 6rem;
  padding-left: 15%;
  padding-right: 20%;
  align-content: center;
  justify-content: left;
  width: 100%;
  border-radius: 0px 8px 8px 0px;
  @media (max-width: 768px) {
    border-radius: 0px 0px 8px 8px;
  }
  @media (max-width: 520px) {
    padding: 24px 8px;
    border-radius: 5px;
    display: grid;
  }
`;

const EsperLogo = styled(Link)`
  justify-self: left;
  position: absolute;
  left: 5rem;
  top: 0;
`;

const SignupButton = styled.div`
  height: 50px;
  padding: 0rem 2rem;
  border: solid 1px #4b5176 !important;
  font-family: 'Nunito Sans', sans-serif;
  cursor: pointer;
  /* margin: 10px; */
  overflow: hidden;
  border-width: 0;
  outline: none;
  border-radius: 4px;
  color: rgb(80, 95, 121);
  font-size: 16px;
  @media (max-width: 768px) {
    font-size: 14px;
  }
  @media (max-width: 520px) {
    font-size: 12px;
    padding: 0rem 1rem;
    height: 2.5rem;
  }
  /* font-weight: 600; */
  font-style: normal;

  min-width: 18rem;
  @media (max-width: 400px) {
    min-width: 250px;
  }
  font-stretch: normal;
  line-height: normal;
  text-rendering: geometricprecision;
  letter-spacing: normal;
  transition: background-color 0.3s;
  box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 5px 0px !important;
  border-width: 0px;
  text-decoration: none;
  border-radius: 3px;
  display: grid;
  background: #fff;
  text-align: center;
  margin-top: 1rem;
  align-items: center;
`;

const SignupSubText = styled(H2)`
  font-family: 'Nunito Sans', sans-serif;
  text-align: left !important;
  margin-bottom: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #6c749b;
`;

const SignUpHeading = styled(H1)`
  color: #654da8;
  margin-top: 1rem;
  text-align: left;
  letter-spacing: -0.85px;

  font-weight: 500;
  margin-bottom: 14px;
  @media (max-width: 768px) {
    width: 100%;
    text-align: left;
    margin-top: 1rem;
  }
`;
const PasswordMatchError = styled.div`
  font-size: 12px;
  color: #c62828;
  margin-top: 6px;
  max-width: 22rem;
  min-height: 21px;
  margin-bottom: 0.5rem;
  font-family: 'Nunito Sans', sans-serif;
`;

const EmailMatch = styled.div`
  font-size: 12px;
  color: grey;
  margin-top: 6px;
  max-width: 22rem;
  min-height: 21px;
  margin-bottom: 0.5rem;
  font-family: 'Nunito Sans', sans-serif;
`;

const FormComponentLeftTitle = styled(H1)`
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  text-align: center !important;
  letter-spacing: normal;
  color: #ffffff;
  @media (max-width: 320px) {
    font-size: 18px;
  }
`;

interface IState {
  email: string;
  emailError: boolean;
  emailLoading: boolean;
  emailSuccess: boolean;
}

export default class ForgotEmail extends React.PureComponent<any, IState> {
  state = {
    email: '',
    password: '',
    emailError: false,
    emailLoading: false,
    emailSuccess: false,
  };

  handleEmailChange = (event: any) =>
    this.setState({ email: event.target.value });

  validateEmail = () => {
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const result = pattern.test(this.state.email);
    if (result === true && this.state.email.length < 150) {
      this.setState({
        emailError: false,
      });
    } else {
      this.setState({
        emailError: true,
        emailSuccess: false,
      });
    }
  };

  sendEmailToUser = () => {
    if (!this.state.emailError && this.state.email.length !== 0) {
      this.setState({ emailLoading: true, emailError: false });
      axios({
        url: `${apiHost.host}get-endpoint`,
        method: 'POST',
        data: {
          email: this.state.email,
        },
      })
        .then((result: any) => {
          this.setState({ emailLoading: false, emailSuccess: true });
        })
        .catch((error: any) => {
          this.setState({ emailLoading: false, emailSuccess: true });
          console.log('error', error);
        });
    } else {
      this.setState({
        emailError: true,
      });
    }
  };

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            andi: file(relativePath: { eq: "v2/signup/andi-signup@3x.png" }) {
              childImageSharp {
                fluid(quality: 85) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }
          }
        `}
        render={(data: any) => (
          <FormComponent style={this.props.style}>
            <FormComponentLeft>
              <EsperLogo aria-label="Esper Logo" title="Esper Logo" to="/">
                <LazyLoadImage
                  alt="Esper logo"
                  style={{
                    height: '44px',
                    width: '180px',
                    marginTop: '2rem',
                    marginBottom: '2rem',
                  }}
                  src={EsperLogoBlue}
                />
              </EsperLogo>
              <ImgDesktop
                fluid={data.andi.childImageSharp.fluid}
                loading="lazy"
                alt="Esper Andi"
              />
              <div>
                <FormComponentLeftTitle>
                  Don’t Have An Account?
                </FormComponentLeftTitle>
                <SignupButton
                  id="homepage__forgot_email__signup"
                  onClick={() => navigate('/signup')}
                >
                  SIGN UP FOR FREE
                </SignupButton>
              </div>
            </FormComponentLeft>
            <FormComponentRight>
              <div
                style={{
                  display: 'grid',
                  justifyItems: 'left',
                }}
              >
                <SignUpHeading>GET ENDPOINT URL ON YOUR EMAIL</SignUpHeading>
                <SignupSubText>
                  Enter your email and we’ll send you the unique endpoint name.
                </SignupSubText>
                <div
                  style={{
                    display: 'grid',
                  }}
                >
                  <StyledInputs
                    id="email"
                    aria-label="Email"
                    backgroundImage={EmailIcon}
                    error={this.state.emailError}
                    onBlur={this.validateEmail}
                    value={this.state.email}
                    maxLength={150}
                    onChange={this.handleEmailChange}
                    placeholder={'Email'}
                    type="text"
                    name="Email"
                  />
                  {this.state.emailError && (
                    <PasswordMatchError id="email-error">
                      Please enter a valid email
                    </PasswordMatchError>
                  )}
                  <EmailMatch>
                    {this.state.emailSuccess && (
                      <>
                        {' '}
                        We've sent you an email with the information about your
                        endpoint. Please contact us at support@esper.io if you
                        do not receive an email.
                        <br />
                      </>
                    )}
                  </EmailMatch>

                  <BlueButtonNew
                    style={{ textTransform: 'unset' }}
                    isLoading={this.state.emailLoading}
                    disabled={this.state.emailLoading}
                    onClick={this.sendEmailToUser}
                    id="homepage__forgot_email__get_my_endpoint_url"
                  >
                    Get my endpoint url
                  </BlueButtonNew>
                </div>
                <div
                  style={{
                    display: 'grid',
                    justifyItems: 'center',
                  }}
                >
                  <MarginDiv>OR</MarginDiv>
                  <WhiteButton
                    style={{ textTransform: 'unset' }}
                    onClick={() => navigate('/login')}
                    id="homepage__forgot_email__login"
                  >
                    Login
                  </WhiteButton>
                </div>
              </div>
            </FormComponentRight>
          </FormComponent>
        )}
      />
    );
  }
}

const MarginDiv = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;
